export default {
  title: "Save Work {entity}",
  label_removed:
    "<b class='text-info'>{entity}</b> <b>removed</b> from <b class='text-info'>Work Order</b>",
  label_added:
    "<b class='text-info'>{entity}</b> <b>added</b> to <b class='text-info'>Work Order</b>",
  label_to_do:
    "<b class='text-info'>{entity}</b> <b>to do</b> on <b class='text-info'>Work Order</b>",
  label_total:
    "Total <b class='text-info'>{entity}</b> <b>included</b> in <b class='text-info'>Work Order</b>",
  label_save_changes: "Do you want to save these changes?",
}
